import { Controller } from '@hotwired/stimulus'
import snackbarCheckImg from 'images/admin/org/snackbar-check.svg'
import { Toast } from 'bootstrap'
import * as liveRegion from '../../helpers/live_region_helper'

export default class extends Controller {
  connect() {
    this.handleToastMessage = this.handleToastMessage.bind(this)
    this.liveRegion = liveRegion.polite
    document.addEventListener('toast', this.handleToastMessage)
    this.showPendingToast()
  }

  // A toast deferred from the previous page (e.g. a save that navigated back via
  // turbo--go-to-previous-page) is stashed in sessionStorage so it can be shown
  // here, after the navigation has landed.
  showPendingToast() {
    const message = sessionStorage.getItem('pendingToast')

    if (!message) return

    // When the previous page also requested a reload, the back navigation fires a
    // restoration visit before the reload lands. Skip it and wait for the reload,
    // otherwise the toast would show on the snapshot that's about to be replaced.
    const navigationType = performance.getEntriesByType('navigation')[0]?.type
    if (sessionStorage.getItem('pendingToastAwaitReload') && navigationType !== 'reload') return

    sessionStorage.removeItem('pendingToast')
    sessionStorage.removeItem('pendingToastAwaitReload')
    document.dispatchEvent(new CustomEvent('toast', { detail: { message } }))
  }

  disconnect() {
    document.removeEventListener('toast', this.handleToastMessage)
  }

  handleToastMessage = (event) => {
    let toastTemplate = `
    <div class="toast hide ${event.detail.failure ? 'failure' : ''}" data-bs-delay="${event.detail.delay || 7000}">
      <div class="d-flex">
        ${this.handleToastImg(event)}
        <div class="${event.detail.failure ? '' : 'ms-2'}">
          ${event.detail.message}
        </div>
      </div>
    </div>
    `
    document.querySelectorAll('.toast').forEach(el => el.remove())
    this.liveRegion.setContent(event.detail.message)
    document.body.insertAdjacentHTML('beforeend', toastTemplate)
    const toastEl = document.querySelector('.toast')
    const toast = new Toast(toastEl)
    toast.show()
  }

  handleToastImg(event) {
    return event.detail.failure ? '' : `<img src="${snackbarCheckImg}" alt=""></img>`
  }
}
